var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.144,
    height: 36.302,
    viewBox: "0 0 106.144 36.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#020202;stroke:#fff;stroke-width:0.5px;}.b{fill:#f9f9f9;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.842 -30.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.15,0H30.2a5.15,5.15,0,0,1,5.15,5.15v25.5A5.15,5.15,0,0,1,30.2,35.8H5.15A5.15,5.15,0,0,1,0,30.653V5.15A5.15,5.15,0,0,1,5.15,0Z",
    transform: "translate(17.092 31)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.02 42.215)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.161,
    height: 12.066,
    transform: "translate(5.969 6.957)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.161,
    height: 19.023,
    transform: "translate(11.715 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.161,
    height: 19.023,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.161,
    height: 11.902,
    transform: "translate(19.377 7.121)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.161,
    height: 3.774,
    transform: "translate(19.377 0.092)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.863 40.421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M435.612,432.961h1.314l2.276,6.065,2.284-6.065H442.8v7.219h-.911v-6.008h-.02l-2.253,6.007H438.8l-2.253-6.007h-.021v6.007h-.91Z",
    transform: "translate(-435.612 -432.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M457.4,432.961h1.063l2.82,7.219h-1.062l-.789-2.175h-3.052l-.808,2.175h-.992Zm-.716,4.235h2.446l-1.2-3.366h-.02Z",
    transform: "translate(-441.66 -432.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M472.36,432.961h3.4c1.352,0,2.194.736,2.194,1.89a1.73,1.73,0,0,1-1.253,1.829v.021c.837.162,1.011.778,1.081,1.485a3.708,3.708,0,0,0,.424,2h-1.073c-.272-.294-.122-1.072-.263-1.779-.1-.708-.272-1.3-1.2-1.3h-2.346v3.085h-.962Zm2.961,3.325c.9,0,1.669-.231,1.669-1.283a1.143,1.143,0,0,0-1.284-1.236H473.32v2.518Z",
    transform: "translate(-447.544 -432.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M489,432.961h.96v3.6l3.661-3.6h1.243l-3.044,2.91,3.166,4.308h-1.213l-2.61-3.65-1.2,1.122v2.529H489Z",
    transform: "translate(-452.899 -432.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M505.248,432.961h4.987v.8h-4.027v2.3h3.751v.81h-3.751v2.5h4.056v.81h-5.016Z",
    transform: "translate(-458.603 -432.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M520.828,433.765h-2.407v-.8H524.2v.8h-2.409v6.412h-.96Z",
    transform: "translate(-462.541 -432.961)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.744 55.405)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M435.659,460.924h.578v4.349h-.578Z",
    transform: "translate(-435.659 -460.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M442.276,460.924h.616l2.291,3.527h.012v-3.527h.548v4.349h-.634l-2.271-3.49h-.013v3.49h-.549Z",
    transform: "translate(-438.414 -460.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M459.5,461.411h-1.45v-.487h3.479v.487h-1.451v3.863H459.5Z",
    transform: "translate(-449.042 -460.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M473.9,460.924h3v.487h-2.425v1.383h2.26v.488h-2.26v1.5h2.443v.488H473.9Z",
    transform: "translate(-458.45 -460.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M488.84,460.924h.578v3.862h2.3v.488H488.84Z",
    transform: "translate(-468.242 -460.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M502.47,460.924h.578v3.862h2.3v.488h-2.881Z",
    transform: "translate(-476.721 -460.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M516.2,460.924h.578v4.349H516.2Z",
    transform: "translate(-485.305 -460.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M525.486,464.437a1.7,1.7,0,0,1-1.4.646,2.084,2.084,0,0,1-2.074-2.095c0-.033,0-.066,0-.1a2.111,2.111,0,0,1,2.071-2.363,1.688,1.688,0,0,1,1.87,1.443h-.578a1.177,1.177,0,0,0-1.292-.956c-1.053,0-1.492.914-1.492,1.846a1.566,1.566,0,0,0,1.492,1.736,1.311,1.311,0,0,0,1.4-1.42H524.1v-.488H526v2.292h-.365Z",
    transform: "translate(-487.256 -460.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M541.23,460.924h3v.487h-2.425v1.383h2.261v.488h-2.261v1.5h2.443v.488h-3.022Z",
    transform: "translate(-500.033 -460.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M556.123,460.924h.615l2.29,3.527h.012v-3.527h.549v4.349h-.634l-2.272-3.49h-.013v3.49h-.548Z",
    transform: "translate(-509.777 -460.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M576.125,461.945a1.145,1.145,0,0,0-1.218-.925c-1.036,0-1.474.853-1.474,1.76,0,.993.438,1.823,1.48,1.823a1.23,1.23,0,0,0,1.254-1.2c0-.017,0-.033,0-.049h.579a1.771,1.771,0,0,1-1.8,1.745l-.085,0a2,2,0,0,1-2.01-2.266,2.063,2.063,0,0,1,2.058-2.29,1.666,1.666,0,0,1,1.792,1.413Z",
    transform: "translate(-520.071 -460.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M591.192,460.924h3v.487h-2.425v1.383h2.261v.488h-2.261v1.5h2.443v.488h-3.022Z",
    transform: "translate(-531.972 -460.82)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.c23527b49f296c185e9f991c5d6da995.svg";
export { ForwardRef as ReactComponent };